import { AvatarGroup, Avatar, Stack } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
export default function Avatars(props) {
  const { data } = props;
  return (
    <Stack direction="row" alignItems="center">
      <AvatarGroup max={2}>
        {data.map(row => (
          <Avatar key={row.picture} src={row.picture} sx={{ width: 30, height: 30 }} />
        ))}
      </AvatarGroup>
      {props.open ? <ExpandLessIcon /> : <ChevronRightIcon />}
    </Stack>
  );
}
